// extracted by css-extract-rspack-plugin
export default {"cls1":"QuestionStyles-cls1__IY","cls2":"QuestionStyles-cls2_eQI QuestionStyles-cls1__IY","multiColumn":"QuestionStyles-multiColumn_v7W"};